"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsNoPoint = exports.selectPointHasNoStream = exports.selectIsPointDisabled = exports.selectIsPointFetched = exports.selectPointData = exports.selectPointStreamId = exports.selectPointMetadata = exports.selectPointIsEnabled = exports.selectPointVolume = exports.selectTimezone = exports.selectCurrentPointId = exports.selectCurrentSpeedLimit = void 0;
var RateLimiting_1 = __importDefault(require("../services/RateLimiting"));
function selectCurrentSpeedLimit(state) {
    var _a;
    if (!state.point.rateLimitSettings)
        return null;
    return RateLimiting_1.default.getCurrentRateLimit(RateLimiting_1.default.limitOptions(state.point.rateLimitSettings, (_a = state.point.timezone) !== null && _a !== void 0 ? _a : "Europe/Moscow"));
}
exports.selectCurrentSpeedLimit = selectCurrentSpeedLimit;
function selectCurrentPointId(state) {
    var _a;
    return (_a = state.point.id) !== null && _a !== void 0 ? _a : null;
}
exports.selectCurrentPointId = selectCurrentPointId;
function selectTimezone(state) {
    var _a;
    return (_a = state.point.timezone) !== null && _a !== void 0 ? _a : "Europe/Moscow";
}
exports.selectTimezone = selectTimezone;
function selectPointVolume(state) {
    return state.point.volume;
}
exports.selectPointVolume = selectPointVolume;
function selectPointIsEnabled(state) {
    return state.point.isEnabled;
}
exports.selectPointIsEnabled = selectPointIsEnabled;
function selectPointMetadata(state) {
    return state.point.metadata;
}
exports.selectPointMetadata = selectPointMetadata;
function selectPointStreamId(state) {
    return state.point.streamId;
}
exports.selectPointStreamId = selectPointStreamId;
function selectPointData(state) {
    return state.point;
}
exports.selectPointData = selectPointData;
function selectIsPointFetched(state) {
    var _a, _b;
    return (_b = (_a = state.point.metadata) === null || _a === void 0 ? void 0 : _a.isFetched) !== null && _b !== void 0 ? _b : false;
}
exports.selectIsPointFetched = selectIsPointFetched;
function selectIsPointDisabled(state) {
    var _a;
    return ((_a = state.point.metadata) === null || _a === void 0 ? void 0 : _a.isFetched) && !state.point.isEnabled;
}
exports.selectIsPointDisabled = selectIsPointDisabled;
function selectPointHasNoStream(state) {
    var _a;
    return ((_a = state.point.metadata) === null || _a === void 0 ? void 0 : _a.isFetched) && !state.point.streamId;
}
exports.selectPointHasNoStream = selectPointHasNoStream;
function selectIsNoPoint(state) {
    var _a;
    return ((_a = state.point.metadata) === null || _a === void 0 ? void 0 : _a.isFetched) && !state.point.id;
}
exports.selectIsNoPoint = selectIsNoPoint;
//# sourceMappingURL=point.js.map